import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Button, Typography,Grid, TextField } from "@material-ui/core";
import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';
import { useDispatch, useSelector } from "react-redux";
import "../../App.css";
import  "./login.css";
import logo from "./../../../src/assets/img/login.jpg";
import { loginUser } from "../../store/action/auth";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { firstAccessibleRoute } from "../../utils/authoritiesUtils";
const useStyles = makeStyles((theme) => ({
    container: {
        display: "flex",
        height: "100vh",
        fontFamily: '"Poppins", sans-serif',
        overflow: 'hidden',
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
        },
    },
    leftSection: {
        display: "flex",
        width: "100%",
        backgroundImage: `url(${logo})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        height: "100vh",
        minHeight: "100vh",
        [theme.breakpoints.down("sm")]: {
            minHeight: "auto",
        },
    },
    rightSection: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "left",
        justifyContent: "center",
        padding: theme.spacing(2),
        height: "100vh",
        width: '100%',
        //marginTop: theme.spacing(6),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1),
        },
    },
    textHeader: {
        marginBottom: theme.spacing(5),
        textAlign: "left",
        color: "#30385A",
        marginTop: theme.spacing(6),
        alignContent: "left",
    },
    textHeader1:{
        fontSize: 30,
        fontFamily:"Poppins",
        fontWeight: 600,
        textWrap: "nowrap",
        color: 'rgb(47, 48, 68)',
        alignContent: "left",
    },
    textHeader2:{
        fontSize: 18,
        fontWeight: 500,
        fontFamily : "Poppins",
        alignContent: "left",
    },

    inputContainer: {
        width: "100%",
        maxWidth: 400,
    },
    field: {
        marginBottom: theme.spacing(2),
    },
    label: {
        fontSize: 14,
        fontWeight: 600,
        color: "rgba(47, 48, 68, 1)",
        fontFamily: '"Poppins", sans-serif',
    },

    cnxBtn: {
        width: "fit-content",
        height: 48,
        borderRadius: theme.shape.borderRadius,
        color: "rgba(255, 255, 255, 1)",
        background: "rgba(187, 200, 8, 1)",
        fontSize: 15,
        marginTop: theme.spacing(2),
        fontFamily: '"Poppins", sans-serif',
        textTransform: 'none',
    },
    footer: {
        marginTop: theme.spacing(18),
        //marginBottom: theme.spacing(4),
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        maxWidth: 400,
    },
    footerText: {
        fontSize: 16,
        fontWeight: 600,
        color: "rgba(187, 200, 8, 1)",
        fontFamily: '"Poppins", sans-serif',
    },
}));

function Login({onLoginSuccess} ) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [email, setEmail] = useState("");
    const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [isFormValid, setIsFormValid] = useState(false);
    const [error, setError] = useState(null);
    const login = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (login.error) {
            setError(login.error);
            toast.error(login.error);
        }
        const token = localStorage.getItem('token');
        const tokenExpiration = localStorage.getItem('tokenExpiration');
        if (token && new Date().getTime() < tokenExpiration) {
            navigate(firstAccessibleRoute() || '/sinistres');
        }
    }, [login.error, navigate]);

    const handleEmailChange = (event) => {
        const value = event.target.value;
        setEmail(value);
        validateForm(value, password);
    };

    const handlePasswordChange = (event) => {
        const value = event.target.value;
        setPassword(value);
        validateForm(email, value);
    };

    const validateForm = (email, password) => {
        setIsFormValid(email.trim() !== '' && password.trim() !== '');
    };

    const handleLogin = async () => {
        if (isFormValid) {
            try {
                setLoading(true)
                await dispatch(loginUser(email, password, () => {
                    // Première page accessible selon les autorisations (expert → /sinistres) ;
                    // PasswordChangeGuard impose d'abord /changer-mot-de-passe si nécessaire
                    navigate(firstAccessibleRoute() || '/sinistres');
                }));

                setLoading(false)
            } catch (error) {
                setError(error.message);
                toast.error(error.message);
            }
        }
    };
 

    return (

        <Grid container >
            <Grid item xs={12} md={6} className={classes.leftSection}></Grid>
            <Grid item sm={6} xs={12} md={4} className={classes.rightSection}>
                <Box className={classes.textHeader}>
                    <Typography className={classes.textHeader1}>
                        Bienvenue à MAE Assurance
                    </Typography>
                    {/* <Typography className={classes.textHeader2}>
                        <span style={{color: 'rgb(167, 168, 187)',}}>New Here?</span>
                        <Link href="/register" sx={{ textDecoration: 'none', color: 'inherit' }}>
                            <span style={{color: 'rgb(187, 200, 8)'}}> Create an Account</span>
                        </Link>
                    </Typography> */}
                </Box>
                <Box className={classes.inputContainer}>
                    <Box className={classes.field} style={{marginBottom:'30px'}}>
                        <Typography className={classes.label}>Email</Typography>
                        <TextField fullWidth  variant="outlined"  inputProps={{ style: { fontSize:15, backgroundColor:"#EEF1F5", borderRadius:5}}}
                                   type="text"
                                   value={email}
                                   onChange={handleEmailChange}
                                   className="TextField-without-border-radius"
                        />
                    </Box>
                    <Box className={classes.field}>
                        <Stack direction={{ xs: 'row', sm: 'row' }} justifyContent="space-between" alignItems="stretch">
                            <Typography  className={classes.label}>Mot de passe</Typography>

                            <Link href="/forgot-password" color="#C5D147" fontFamily={"Poppins"} fontSize={14} fontWeight={600}
                                  sx={{ textDecoration: 'none', color: 'inherit', '&:hover': { color: '#C5D147' } }}>
                                <span style={{color: 'rgb(187, 200, 8)'}}> Mot de passe oublié ?</span>
                            </Link>

                        </Stack>
                        <TextField fullWidth  variant="outlined" inputProps={{ style: { fontSize:15, backgroundColor:"#EEF1F5",borderRadius:5}}} type="password"
                                   value={password} className="TextField-without-border-radius"
                                   onChange={handlePasswordChange}
                        />
                                             {error && <span className={classes.specialInputL} style={{ color: "white", backgroundColor: "red", width: "98%", borderRadius: "2px", marginTop: "0.25rem", padding: "4px", height: "auto", display: "inline-flex", textAlign: "center", borderRadius:"4px",justifyContent:"center"}}>{error}</span>}

                    </Box>

                    <Button
                        className={`${classes.cnxBtn} disable-hover`}
                        type="submit"
                        onClick={handleLogin}
                        disabled={!isFormValid || loading}
                        style={{fontFamily : '"Poppins", sans-serif',
                        }}
                    >
                            Se Connecter
                    </Button>
                </Box>
                <Box className={classes.footer}>
                    <Box sx={{ width: '100%', margin: 'auto' }}>
                        <Stack direction={{ xs: 'row', sm: 'row' }} spacing={{ xs: 1, sm: 2, md: 4 }} justifyContent="start" alignItems="start">
                            <Typography className={classes.footerText}>Terms</Typography>
                            <Typography className={classes.footerText}>Plans</Typography>
                            <Typography className={classes.footerText}>Contact Us</Typography>
                        </Stack>
                    </Box>
                </Box>
            </Grid>
        </Grid>

    );
}

export default Login;
